import { render, staticRenderFns } from "./OfferCreation.vue?vue&type=template&id=37e4bf8e&scoped=true&"
import script from "./OfferCreation.vue?vue&type=script&lang=ts&"
export * from "./OfferCreation.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCreation.vue?vue&type=style&index=0&id=37e4bf8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4bf8e",
  null
  
)

export default component.exports